import React from "react";

function initials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

/** Pinned member context strip — shown on Screens 0–3 */
export default function MemberStrip({ memberName, partnerName }) {
  const subtitle = partnerName
    ? `${partnerName} Autopay Setup`
    : "Navadhan Autopay Setup";
  return (
    <div
      style={{
        background: "#f0fdf4",
        border: "1px solid #bbf7d0",
        borderRadius: 12,
        margin: "8px 12px 0",
        padding: "8px 12px",
        display: "flex",
        alignItems: "center",
        gap: 10,
      }}
    >
      <div
        style={{
          width: 38,
          height: 38,
          borderRadius: "50%",
          background: "#166534",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: 14,
          flexShrink: 0,
        }}
      >
        {initials(memberName)}
      </div>
      <div>
        <div style={{ fontWeight: 700, fontSize: 14, color: "#14532d" }}>
          {memberName}
        </div>
        <div style={{ fontSize: 11, color: "#6b7280" }}>
          {subtitle}
        </div>
      </div>
    </div>
  );
}
